import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { htmlSafe } from '@ember/template';
import { t } from 'ember-intl';
import revealOnScroll from 'madow-tech/modifiers/reveal-on-scroll';
import mult from 'madow-tech/helpers/mult';

const tech = [
  { name: 'TypeScript', color: '#3178C6' },
  { name: 'Ember.js', color: '#E04E39' },
  { name: 'JavaScript', color: '#F7DF1E' },
  { name: 'Node.js', color: '#339933' },
  { name: 'Nest.js', color: '#E0234E' },
  { name: 'PostgresSQL', color: '#4169E1' },
  { name: 'MongoDB', color: '#47A248' },
  { name: 'Elastic Search', color: '#005571' },
  { name: 'Docker', color: '#2496ED' },
  { name: 'Python', color: '#3776AB' },
  { name: 'React', color: '#61DAFB' },
  { name: 'DynamoDB', color: '#4053D6' },
  { name: 'RDS Datalake', color: '#527FFF' },
  { name: 'Oracle VPS', color: '#F80000' },
  { name: 'N8N', color: '#EA4B71' },
  { name: 'PHP', color: '#777BB4' },
  { name: 'KurierJS', color: '#F5A623' },
  { name: 'Warp-Drive', color: '#E04E39' },
  { name: 'Nginx', color: '#009639' },
  { name: 'TurboRepo', color: '#EF4444' },
  { name: 'WebGL', color: '#990000' },
  { name: 'Supabase', color: '#3ECF8E' },
];

export default class TechnologiesGrid extends Component {
  get techList() {
    return tech;
  }

  @action
  imgUrl(techObj: { name: string; color: string }) {
    return `/icons/${techObj.name}.svg`;
  }

  @action
  techIconStyle(techObj: { name: string; color: string }) {
    const color = techObj.color.match(/^#[0-9A-Fa-f]{3,6}$/)
      ? techObj.color
      : '#000';
    return htmlSafe(
      `filter: drop-shadow(0px 0px 5px ${color}) brightness(0.9) contrast(1.1);`,
    );
  }

  <template>
    <section id="technologies" class="py-20 md:py-28">
      <div class="mx-auto max-w-7xl px-4">
        <h2 class="text-3xl md:text-4xl font-bold text-center mb-4">{{t "technologies.title"}}</h2>
        <p class="mt-0 mb-2 max-w-3xl text-zinc-300 text-center mx-auto text-base md:text-lg">{{t "technologies.intro"}}</p>
        <p class="mt-0 mb-12 md:mb-16 text-sm text-zinc-400 text-center italic">"{{t "technologies.tagline"}}"</p>
        <div class="flex flex-wrap justify-center mx-auto gap-x-4 md:gap-x-6 gap-y-5 md:gap-y-10 max-w-3xl">
          {{#each tech as |techItem i|}}
            <div
              class="tech-item-container group relative flex flex-col items-center"
              {{revealOnScroll animation="zoom-in" delay=(mult i 50)}}
            >
              <div class="tech-icon-wrapper cursor-pointer border-0 bg-transparent">
                <img
                  src={{this.imgUrl techItem}}
                  alt={{techItem.name}}
                  class="tech-icon w-16 h-16 transition-transform duration-300 ease-out group-hover:scale-110"
                  style={{this.techIconStyle techItem}}
                />
              </div>
              <span
                class="tech-label mt-2 opacity-0 -translate-y-2 text-xs font-semibold text-white whitespace-nowrap transition-all duration-300 ease-out group-hover:opacity-100 group-hover:translate-y-0"
              >
                {{techItem.name}}
              </span>
            </div>
          {{/each}}
        </div>
      </div>
    </section>
  </template>
}
